import Header from "../../components/Header";
import Footer from "../../components/Footer";

export default function Main2023() {
  const handleDownload1 = () => {
    window.open("assets/2023/tc.pdf", "_blank");
  };
  const handleDownload2 = () => {
    window.open("assets/2023/james.pdf", "_blank");
  };
  const handleDownload3 = () => {
    window.open("assets/2023/lalmuan.pdf", "_blank");
  };
  const handleDownload4 = () => {
    window.open("assets/2023/lb.pdf", "_blank");
  };
  const handleDownload5 = () => {
    window.open("assets/2023/rlal.pdf", "_blank");
  };
  const handleDownload6 = () => {
    window.open("assets/2023/C.Van.pdf", "_blank");
  };
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className=" h-full justify-center items-center flex mx-20">
        <div className="flex flex-col-reverse lg:flex-row  justify-center items-center">
          {/* Book Cover */}
          <div className=" mr-20 sm:mt-0 md:mt-20 mt-20 flex flex-col justify-center items-center">
            <img className="h-96 w-60" src="mea.webp" />
            <div className=" text-center font-semibold">ISSN 2581-7523</div>
          </div>
          {/* Main Page */}
          <div className="">
            <div className="">
              <div className=" font-bold text-xl">Mizoram Economic Review</div>
              <div className="text-sm">Volume 6, No. 1&2 (2023)</div>
              <div className="text-sm">ISSN 2581-7523</div>
            </div>

            {/* Content */}
            <div className="mt-10 grid grid-row-1 gap-6">
              <button className="text-left" onClick={handleDownload1}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Review of the Strategies of Rural Development Policy in
                  Mizoram
                </div>
                <div className="text-sm text-green-600">Prof. T.C. Nunga</div>
              </button>
              <button className="text-left" onClick={handleDownload2}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Changing Dimensions ofAgricultural Policies and Trade Reforms
                  in India and China
                </div>
                <div className="text-sm text-green-600">
                  James L.T. Thanga & Vanlalkhumtiri Chhangte
                </div>
              </button>
              <button className="text-left" onClick={handleDownload3}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Processing and Value Addition of Arecanut Dry Leaf on
                  Sustainable Livelihoods in Mizoram
                </div>
                <div className="text-sm text-green-600">
                  Lalmuansangi & Prof. Giribabu.M
                </div>
              </button>
              <button className="text-left" onClick={handleDownload4}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Physical Quality of Life Index in Lunglei District, Mizoram
                </div>
                <div className="text-sm text-green-600">
                  LB Ngoze, Tuanmuansanga & Dr. Lalhriatpuii
                </div>
              </button>
              <button className="text-left" onClick={handleDownload5}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  An EmpiricalAnalysis of Rental Housing Market under Aizawl
                  Municipal Corporation
                </div>
                <div className="text-sm text-green-600">R. Lalbiakzuala</div>
              </button>
              <button className="text-left" onClick={handleDownload6}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Religious Identityof the Mizos
                </div>
                <div className="text-sm text-green-600">
                  Prof. C. Vanlalhruaia
                </div>
              </button>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
